import { defineStore } from 'pinia'
import serviceConfig from '@/config'

const setItem = (state, data) => {
  for (const key in data) {
    if (Array.isArray(data[key])) {
      state[key] = data[key]
    } else if (typeof data[key] === 'object') {
      if (!Object.keys(data[key] || {}).length) {
        state[key] = {} // 如果新对象是空直接覆盖成空对象
      } else {
        state[key] = { ...state[key], ...data[key] } // 保证差异更新
      }
    } else {
      state[key] = data[key]
    }
  }
}

export const useAppStore = defineStore('app', {
  state: () => ({
    serviceConfig: serviceConfig,
    user: {},
    selectedCity: {},
    productDetail: {},
    instructions: {},
    cityIdList: [],
    limitInfo: {},
    productCity0: [], // 国家历史记录
    useScoreSelected: true, // 积分抵现是否勾选，默认勾选
    useCouponSelected: true, // 本单优惠是否勾选，默认勾选
    useBestPriceObj: {}, // 最佳优惠券对象（带持久化）
  }),
  getters: {
    getSelectedCity: state => {
      const cityList = state.cityIdList || []
      if (!Object.keys(state.selectedCity).length && cityList.length) {
        const localCity = sessionStorage.getItem('localCity')
        if (localCity) {
          // 当前定位城市在出发城市列表中
          const currentCity = cityList.find(c => c.cityCnName === localCity)
          if (currentCity) {
            return {
              ...currentCity,
              cityCnName: localCity,
            }
          } else {
            return {
              ...cityList[0],
              cityCnName: cityList[0].cityCnName,
            }
          }
        }
      }
      return state.selectedCity
    },
  },
  actions: {
    setSelectedCity(data) {
      setItem(this.selectedCity, data)
    },
    setInstructions(data) {
      setItem(this.instructions, data)
    },
    setProductDetail(data) {
      setItem(this.productDetail, data)
    },
    setCityIdList(data) {
      setItem(this.cityIdList, data)
    },
    setLimitInfo(data) {
      setItem(this.limitInfo, data)
    },
    setItem(data) {
      setItem(this, data)
    },
    setUseScoreSelected(value) {
      this.useScoreSelected = value
    },
    setUseCouponSelected(value) {
      this.useCouponSelected = value
    },
    setBestPriceObj(data) {
      setItem(this.useBestPriceObj, data)
      console.log('data------>>>', this.useBestPriceObj)
      // 直接替换引用并持久化，空对象则重置为空
      // const next = (data && Object.keys(data).length) ? { ...data } : {}
      // this.useBestPriceObj = next
      // try {
      //     sessionStorage.setItem('bestPriceObj', JSON.stringify(next))
      // } catch (e) {
      //     // ignore
      // }
    },
  },
})
